import React, { useEffect, useState } from 'react'
import { createSelector } from 'reselect'
import { useSelector, useDispatch } from 'react-redux'
import {
  Grid,
  Box,
  ListItem,
  List,
  Button,
  IconButton,
  TextField,
  Snackbar,
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import CurrencyFormat from 'react-currency-format'

//ICONS
import RemoveIcon from '@material-ui/icons/Remove'
import AddIcon from '@material-ui/icons/Add'
import MotorcycleIcon from '@material-ui/icons/Motorcycle'
import LocalMallIcon from '@material-ui/icons/LocalMall'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import ClearIcon from '@material-ui/icons/Clear'

//COMPONENTS
import SearchLocationInpunt from '../SearchLocationInput/SearchLocationInpunt'

//HELPERS
import { addArrayItems } from '../../utils/helpers'

//REDUX
import { makeSelectSingleExperience } from '../../redux/ducks/experiences'
import {
  set_total_order_price,
  set_order_products,
  set_order_indications,
  set_delivery_address,
  set_dispatch_method,
  makeSelectOrderProducts,
  makeSelectOrderIndications,
  makeSelectDeliveryAddress,
  makeSelectDispatchMethod,
  makeSelectTotalOrderPrice,
} from '../../redux/ducks/restaurantMenu'

const stateSelector = createSelector(
  [
    makeSelectOrderProducts,
    makeSelectOrderIndications,
    makeSelectDeliveryAddress,
    makeSelectDispatchMethod,
    makeSelectSingleExperience,
    makeSelectTotalOrderPrice,
  ],
  (
    orderProducts,
    orderIndications,
    deliveryAddress,
    dispatchMethod,
    singleExperience,
    totalOrderPrice,
  ) => ({
    orderProducts,
    orderIndications,
    deliveryAddress,
    dispatchMethod,
    singleExperience,
    totalOrderPrice,
  }),
)

const actionDispatch = (dispatch) => ({
  setTotalOrderPrice: (totalOrderPrice) =>
    dispatch(set_total_order_price(totalOrderPrice)),
  setOrderProducts: (orderProducts) =>
    dispatch(set_order_products(orderProducts)),
  setOrderIndications: (orderIndications) =>
    dispatch(set_order_indications(orderIndications)),
  setDeliveryAddress: (deliveryAddress) =>
    dispatch(set_delivery_address(deliveryAddress)),
  setDispatchMethod: (dispatchMethod) =>
    dispatch(set_dispatch_method(dispatchMethod)),
})

const ShoppingCart = ({ type, handleNext }) => {
  //REDUX STATES
  const {
    orderProducts,
    orderIndications,
    deliveryAddress,
    dispatchMethod,
    singleExperience,
    totalOrderPrice,
  } = useSelector(stateSelector)
  const {
    setOrderProducts,
    setTotalOrderPrice,
    setOrderIndications,
    setDeliveryAddress,
    setDispatchMethod,
  } = actionDispatch(useDispatch())

  //COMPONENTE STATE
  const [deliveryTime, setDeliveryTime] = useState('')
  const [location, setLocation] = useState('')
  const [isOrderValid, setIsOrderValid] = useState({
    message: '',
    isValid: true,
  })
  const [isLocationValid, setIsLocationValid] = useState(true)
  const [snackOpen, setSnackOpen] = useState({ isOpen: false, message: '' })

  useEffect(() => {
    if (deliveryAddress.formatted_address) {
      getDistanceMatrix(
        singleExperience.locator.formatted_address,
        deliveryAddress.formatted_address,
      )
    }
    if (type === 'ECOMMERCE') {
      setDispatchMethod('pickup')
    }
  }, [deliveryAddress])

  const getDistanceMatrix = (origin, destination) => {
    const distanceMatrixService = new window.google.maps.DistanceMatrixService()
    distanceMatrixService.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: 'DRIVING',
      },
      handleDistanceMatrix,
    )
  }

  const handleDistanceMatrix = (response) => {
    //se le agregar 25min(1500seg) aprox a la preparacion del pedido
    const seconds = response.rows[0].elements[0].duration.value + 1500

    const d = Math.floor(seconds / (3600 * 24))
    const h = Math.floor((seconds % (3600 * 24)) / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    //   const s = Math.floor(seconds % 60)

    const dDisplay = d > 0 ? d + (d === 1 ? ' dia ' : ' dias ') : ''
    const hDisplay = h > 0 ? h + (h === 1 ? ' hora ' : ' horas ') : ''
    const mDisplay = m > 0 ? m + (m === 1 ? ' minuto ' : ' minutos ') : ''
    // const sDisplay = s > 0 ? s + (s === 1 ? ' segundo' : ' seconds') : ''

    if (dDisplay) {
      setDeliveryTime(dDisplay + hDisplay)
    } else if (hDisplay) {
      setDeliveryTime(hDisplay + mDisplay)
    } else {
      setDeliveryTime(mDisplay)
    }
  }

  const handleTotalOrderPrice = () => {
    const productsPriceArray = orderProducts.map((product) => product.price)

    const productsTotal = addArrayItems(productsPriceArray)
    setTotalOrderPrice(productsTotal)
    return productsTotal
  }

  const handleRemoveProduct = (product) => {
    const updatedOrderProducts = orderProducts.filter(
      (orderProduct) => orderProduct.key !== product.key,
    )
    setDeliveryTime('')
    setDispatchMethod('')
    setDeliveryAddress({})
    setOrderProducts(updatedOrderProducts)
    setIsOrderValid({ message: '', isValid: true })
  }

  const handleAddProduct = (order) => {
    const updatedOrderProducts = orderProducts.map((orderProduct) => {
      if (orderProduct.key === order.key) {
        const updatedAmount = orderProduct.amount + 1
        const updatedPrice = updatedAmount * orderProduct.basePrice
        return { ...orderProduct, amount: updatedAmount, price: updatedPrice }
      } else {
        return orderProduct
      }
    })
    setOrderProducts(updatedOrderProducts)
  }

  const handleReduceProduct = (order) => {
    if (order.amount > 1) {
      const updatedOrderProducts = orderProducts.map((orderProduct) => {
        if (orderProduct.key === order.key) {
          const updatedAmount = orderProduct.amount - 1
          const updatedPrice = updatedAmount * orderProduct.basePrice
          return { ...orderProduct, amount: updatedAmount, price: updatedPrice }
        } else {
          return orderProduct
        }
      })
      setOrderProducts(updatedOrderProducts)
    }
  }

  const handleContinue = () => {
    if (totalOrderPrice < 1000) {
      setSnackOpen({
        ...snackOpen,
        isOpen: true,
        message: 'El total del pedido no puede ser menor a $1000',
      })
      return
    }
    if (dispatchMethod === 'delivery') {
      if (location) {
        handleNext()
      } else {
        setIsLocationValid(false)
        setIsOrderValid({
          message: 'Por favor, ingrese su direccion.',
          isValid: false,
        })
      }
    } else if (dispatchMethod === 'pickup') {
      handleNext()
    } else {
      setIsOrderValid({
        message: 'Por favor, seleccione un metodo de despacho',
        isValid: false,
      })
    }
  }

  const handleClose = () => {
    setSnackOpen({ ...snackOpen, isOpen: false })
  }

  if (!orderProducts.length) {
    return (
      <Grid item xs={12}>
        <Box textAlign="center">
          <ShoppingCartIcon
            style={{ fontSize: 100, color: '#3A3A3A', opacity: 0.3 }}
          />
          <Box
            component="p"
            color="#3A3A3A"
            // css={{ opacity: 0.3, fontWeight: 'bold' }}
            m={0}
          >
            Tu carrito esta vacio
          </Box>
        </Box>
      </Grid>
    )
  }

  return (
    <>
      <Grid
        item
        xs={12}
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {type === 'ECOMMERCE' && dispatchMethod === 'delivery' ? (
          <Box
            height="80px"
            border={dispatchMethod === 'delivery' ? '2px solid #673AB7' : ''}
            borderRadius="10px"
            width="100%"
            textAlign="center"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            css={{ cursor: 'pointer' }}
            onClick={() => setDispatchMethod('delivery')}
          >
            <MotorcycleIcon style={{ fontSize: 40 }} color="primary" />
            <Box component="p" m={0}>
              Delivery
            </Box>
          </Box>
        ) : (
          <>
            <Box
              height="80px"
              border={dispatchMethod === 'pickup' ? '2px solid #673AB7' : ''}
              borderRadius="10px"
              width="100%"
              textAlign="center"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              css={{ cursor: 'pointer' }}
              onClick={() => {
                setIsLocationValid(true)
                setIsOrderValid({ message: '', isValid: true })
                setDispatchMethod('pickup')
                setDeliveryAddress({})
              }}
            >
              <LocalMallIcon style={{ fontSize: 40 }} color="primary" />
              <Box component="p" m={0}>
                Retiro en tienda
              </Box>
            </Box>
          </>
        )}
      </Grid>
      {dispatchMethod === 'delivery' && (
        <Grid item xs={12}>
          <Box>
            <SearchLocationInpunt
              isValid={isLocationValid}
              setAddress={setDeliveryAddress}
              helperText={
                singleExperience.category === 'RESTAURANT' && deliveryTime
              }
              locationString={location}
              setLocationString={setLocation}
            />

            <TextField
              label="Indicaciones de entrega"
              multiline
              rows={3}
              variant="outlined"
              value={orderIndications}
              onChange={(event) => setOrderIndications(event.target.value)}
            />
          </Box>
        </Grid>
      )}
      <Grid item xs={12}>
        <List dense>
          {orderProducts.map((item) => (
            <ListItem
              key={item.key}
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <Box display="flex" alignItems="center">
                <IconButton
                  color="primary"
                  size="small"
                  onClick={() => handleReduceProduct(item)}
                >
                  <RemoveIcon />
                </IconButton>
                <Box
                  container="span"
                  style={{ fontSize: '1.3rem', fontWeight: 'bold' }}
                  paddingX={1}
                >
                  {item.amount}
                </Box>
                <IconButton
                  color="primary"
                  size="small"
                  onClick={() => handleAddProduct(item)}
                >
                  <AddIcon />
                </IconButton>
              </Box>
              <Box display="flex" justifyContent="space-between" width="100%">
                <span> {item.name}</span>
                <CurrencyFormat
                  value={item.price}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />
              </Box>
              <IconButton
                size="small"
                color="primary"
                aria-label="remove-product"
                onClick={() => handleRemoveProduct(item)}
              >
                <ClearIcon />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Grid>
      <Grid item xs={12}>
        <Box
          borderTop="2px solid #673ab7"
          css={{ fontWeight: 'bold' }}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <span>Total</span>
          <CurrencyFormat
            value={handleTotalOrderPrice()}
            displayType="text"
            thousandSeparator
            prefix="$"
            style={{ fontSize: '1.2rem' }}
          />
        </Box>
      </Grid>

      <Grid item xs={12}>
        {!isOrderValid.isValid && (
          <Alert severity="error">{isOrderValid.message}</Alert>
        )}
        <Box textAlign="end" mt={2}>
          <Button color="primary" variant="contained" onClick={handleContinue}>
            Continuar
          </Button>
        </Box>
      </Grid>
      <Snackbar
        open={snackOpen.isOpen}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert severity="error">{snackOpen.message}</Alert>
      </Snackbar>
    </>
  )
}

export default ShoppingCart
